export const maxNAICSLen = 6;
export const minNAICSLen = 4;
export const minNAICSVal = 1000;
export const maxNAICSVal = 999999;
export const minZipLen = 5;
export const maxZipLen = 10;
export const einLen = 9;
export const REG_EX_NUMERIC = /^[0-9]+$/ ;
export const zipCodePattern = /^\d{5}-\d{4}/;


/** WEBPACK FOOTER **
 ** ./src/constants/EstablishmentEditConstants.js
 **/